import React from 'react'
import Header from '../components/navbar/Header';
import Footer from '../components/footer/Footer';
import About from '../components/about/About';



const about = () => {
    return (
        <>
            <Header />
            <About />
            <Footer />
        </>
    )
}

export default about